<template>
  <v-dialog persistent
            v-model="show"
            width="500px">
    <v-card>
      <v-card-title>Contact Person</v-card-title>
      <v-card-text>
        <v-row class="pb-0">
          <v-col cols="12">
            <v-select
                :disabled="isLoading"
                :items="companyContactDesignations"
                item-text="value"
                item-value="key"
                label="Designation"
                v-model="currentContact.designation"/>
          </v-col>
          <v-col cols="12">
            <v-text-field
                :disabled="isLoading"
                :rules="[rules.lengthRule(100)]"
                label="Name"
                v-model="currentContact.name"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                :disabled="isLoading"
                :rules="[rules.lengthRule(100)]"
                label="Surname"
                v-model="currentContact.surname"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                :disabled="isLoading"
                :rules="[rules.lengthRule(100)]"
                label="Email"
                v-model="currentContact.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                :disabled="isLoading"
                :rules="[rules.lengthRule(100)]"
                label="Number"
                v-model="currentContact.number"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close"
               class="text-none"
               color="secondary darken-1"
               text
        >Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="isLoading"
               :loading="isLoading"
               @click="saveContact"
               class="text-none"
               color="secondary darken-1"
               text>Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CompanyContactAddEditDialog",
  props: ['companyId', 'show', 'companyContactDesignations', 'contact'],
  data() {
    return {
      isLoading: false,
      currentContact: {
        id: 0,
        name: "",
        surname: "",
        email: "",
        number: "",
        designation: 1,
      },
      rules: {
        requiredRule: v => !!v || "required",
        lengthRule: limit => v => !v || v.length <= limit || "exceeds " + limit + " characters",
      }
    }
  },
  methods: {
    saveContact() {
      this.isLoading = true;

      if (this.currentContact.id > 0) {
        this.updateContact();
      } else {
        this.addContact();
      }

    },
    addContact() {
      let customerCompanyContact = this.currentContact;
      customerCompanyContact.customerCompanyId = this.companyId;

      this.$store
          .dispatch("companies/addcontact", {
            companyid: this.companyId,
            customercompanycontact: customerCompanyContact
          })
          .then(
              (responseId) => {

                this.$emit("contact-added", {
                  id: responseId,
                  name: this.currentContact.name,
                  surname: this.currentContact.surname,
                  email: this.currentContact.email,
                  number: this.currentContact.number,
                  designation: this.currentContact.designation,
                });

              },
              error => this.notify(error.response.data, "error")
          )
          .finally(this.resetAndClose);
    },
    updateContact() {
      let customerCompanyContact = this.currentContact;
      customerCompanyContact.customerCompanyId = this.companyId;

      this.$store
          .dispatch("companies/updatecontact", {
            companyid: this.companyId,
            customercompanycontact: customerCompanyContact
          })
          .then(
              (responseId) => {
                this.$emit("contact-updated", customerCompanyContact, {
                  id: responseId,
                  name: this.currentContact.name,
                  surname: this.currentContact.surname,
                  email: this.currentContact.email,
                  number: this.currentContact.number,
                  designation: this.currentContact.designation,
                });

              },
              error => this.notify(error.response.data, "error")
          )
          .finally(this.resetAndClose);
    },
    close() {
      this.$emit('close');
    },
    resetAndClose() {
      this.isLoading = false;
      this.currentContact = {
        name: "",
        surname: "",
        email: "",
        number: "",
        designation: 1,
      };
      this.close();
    }
  },
  watch: {
    contact(newValue) {
      if (this.contact != null) {
        this.currentContact = newValue;
      }
    }
  }
}
</script>

<style scoped>

</style>
